import { Parceiro } from "./parceiro";

export class Autenticado {
  cdMsgemRetorno: string;
  dsMsgemRetorno: string;
  nuCTRL: string;
  parceiro: Parceiro;
  nmCliente?: string;
  nuCpfCnpj?: string;
  nuCpfCnpjFormatado?: string;
  cdTipoCpfCnpj?: string;
  nuCpfCnpjText?:string;
  tempoSessao?: string;
  keyCaptcha?: string;
  txtCaptcha?: string;
  vrSenha?: string;
  nuDdd?: string;
  nuCelular?: string;
  nmEmail?: string;
}

export class LoginRequest {
  cdMidia: number;
  nuCpfCnpj: string;
  cdTipoCpfCnpj: string;
  vrSenha: string;
  token?: string;
  keyCaptcha?: string;
  txtCaptcha?: string;
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/modelo/autenticado.ts